module.exports = __webpack_public_path__ + "static/media/UserManualSiteStaffScannerAndResolver.31a7dc6e.pdf";